// Maps a portal's configured summaryEngine code (from GET /get-summary-engine)
// to the route it should render. Adding a future Summary Type 3+ is: add a
// route module, add one entry here, extend the backend enum, add an admin
// dropdown option — no existing branch needs editing.
export const SUMMARY_ENGINE_ROUTE: Record<string, string> = {
  v1: '/summary',
  v2: '/summary-v2',
};
